<div class="flex w-full flex-col pl-4 mt-2">
  <div class="flex w-full justify-between" *ngIf="!question.questionPublished">
    <div class="font-medium">
      <span class="font-bold">Q: </span>
      {{question.questionAsked}}
    </div>
  </div>
  <div class="flex w-full justify-between" *ngIf="question.questionPublished">
    <div class="font-medium">
      <span class="font-bold">Q: </span>
      {{question.questionPublished}}
    </div>
    <button mat-button color="primary" (click)="askQuestion()" class="flex-none self-start" *ngIf="question.answer && !locked">
      <mat-icon class="text-xs">help</mat-icon>
      Ask Followup
    </button>
  </div>
  <div *ngIf="question.questionPublished">
    <div class="font-normal">
      <span class="font-bold">A: </span>
      {{question.answer}}
    </div>
  </div>
  <div class="border-b-2 mt-2"></div>
  <app-install-question *ngFor="let question of question.questions" (updateQuestionEmitter)="handleUpdateQuestionEmitter()"
                       [locked]="locked" [installerId]="installerId" [installBidId]="installBidId" [question]="question">
  </app-install-question>

</div>
